<!--
  This icon is designed especially for Dierenbescherming and not from an icon set,
  so be careful reusing it in other projects.
  -->

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true">
    <path fill="currentColor" d="M13.9 24V13.1h3.7l.6-4.3H14V6.1c-.1-1.3.2-2.1 2-2.1h2.3V.2c-.5-.1-1.8-.2-3.4-.2-3.3 0-5.5 2-5.5 5.6v3.1H5.8V13h3.7v11h4.4z" />
  </svg>
</template>
